/**
 * TODO: There is a TS PR that has already extracted some of these objects
 * after merger of that PR these constants should be deleted
 */

export const NUMBER_SEPARATOR = {
    COMMA: 'COMMA',
    DOT: 'DOT',
    UNKNOWN: 'UNKNOWN',
} as const;

export const NUMBER_SEPARATORS = Object.values(NUMBER_SEPARATOR);

export const TABLE_MODE = {
    NORMAL: 'NORMAL',
    CELL_CONFIDENCE: 'CELL_CONFIDENCE',
    CELL_DATA_CONFIDENCE: 'CELL_DATA_CONFIDENCE',
    DATA_TYPE: 'DATA_TYPE',
} as const;

export const MODE_LABEL = {
    [TABLE_MODE.NORMAL]: 'Normal',
    [TABLE_MODE.CELL_CONFIDENCE]: 'Cell confidence',
    [TABLE_MODE.CELL_DATA_CONFIDENCE]: 'Cell data confidence',
    [TABLE_MODE.DATA_TYPE]: 'Cell data type',
} as const;

export const TABLE_MODES = Object.values(TABLE_MODE);

export const COLUMN_TYPE = {
    FIELD_NAMES: 'FIELD_NAMES',
    NOTES: 'NOTES',
    CHANGE: 'CHANGE',
    REPORT: 'REPORT',
    OTHER: 'OTHER',
    EMPTY: 'EMPTY',
    SCALE: 'SCALE',
    ADJUSTMENT: 'ADJUSTMENT',
} as const;

export const COLUMN_TYPES = Object.values(COLUMN_TYPE);

export const ROW_TYPE = {
    HEADLINE: 'HEADLINE',
    FINANCIAL_DATA: 'FINANCIAL_DATA',
    TABLE_HEADER: 'TABLE_HEADER',
    EMPTY: 'EMPTY',
} as const;

export const ROW_TYPES = Object.values(ROW_TYPE);

export const REPORT_PROP = {
    YEAR: 'year',
    PERIOD: 'period',
    VERSION: 'version',
    FORMAT: 'format',
    SCALE: 'scale',
} as const;

export const REPORT_PROPERTIES = Object.values(REPORT_PROP);

export const PERIOD = {
    Q1: 'Q1',
    Q2: 'Q2',
    H1: 'H1',
    Q3: 'Q3',
    '9M': '9M',
    Q4: 'Q4',
    H2: 'H2',
    FY: 'FY',
} as const;

export const PERIODS = Object.values(PERIOD);

export const MATCHING_TIME_PERIODS: (typeof PERIODS)[number][][] = [
    [PERIOD.H1, PERIOD.Q2],
    [PERIOD.FY, PERIOD.H2, PERIOD.Q4],
    [PERIOD['9M'], PERIOD.Q3],
];

export const VERSION = {
    ORIGINAL: 'ORIGINAL',
    LATEST: 'LATEST',
} as const;

export const VERSIONS = Object.values(VERSION);

export const FORMAT = {
    STANDARD: 'STANDARD',
    CONDENSED: 'CONDENSED',
    PROFORMA: 'PROFORMA',
} as const;

export const FORMATS = Object.values(FORMAT);

export const BLOCK_TYPE = {
    TABLE: 'TABLE',
    TEXT_LINE: 'TEXT_LINE',
} as const;

export const TEMPORARY_ROW_ID_PREFIX = 'TMP:ROW:ID:' as const;
export const TEMPORARY_DESCRIPTOR_ID_PREFIX = 'TMP:DESCRIPTOR:ID:' as const;
//TODO: Merge IMPORT_DESCRIPTOR_TYPE and DescriptorType
export const IMPORT_DESCRIPTOR_TYPE = {
    ANY: 'ANY',
    HEADLINE: 'HEADLINE',
    NUMBER: 'NUMBER',
    PERCENT: 'PERCENT',
} as const;

export const IMPORT_DESCRIPTOR_TYPES = Object.values(IMPORT_DESCRIPTOR_TYPE);

export const IMPORT_DESCRIPTOR_SOURCE = {
    IMPORT_FILE: 'IMPORT_FILE',
    MASTER_TABLE: 'MASTER_TABLE',
} as const;

export const FIELD_VALUE_CONFIRMATION = {
    CALCULATION_CONFIRMED: 'CALCULATION_CONFIRMED',
    CONFIRMED_AS_CALCULATION_ARGUMENT: 'CONFIRMED_AS_CALCULATION_ARGUMENT ',
} as const;

export const FIELD_VALUE_SOURCE = {
    CALCULATION: 'CALCULATION',
    DESCRIPTOR_ADDITION: 'DESCRIPTOR_ADDITION',
    FILLER: 'FILLER',
    IMPORT_FILE: 'IMPORT_FILE',
    MASTER_TABLE: 'MASTER_TABLE',
} as const;

export const FIELD_VALUE_WARNING = {
    DISABLED_CALCULATION: 'DISABLED_CALCULATION',
    FORMAT_DETECTION: 'FORMAT_DETECTION',
    HIGH_CORRECTION: 'HIGH_CORRECTION',
    INVALID_NUMBER: 'INVALID_NUMBER',
    SIGN_CORRECTION: 'SIGN_CORRECTION',
    UNEXPECTED_CALCULATION_ERROR: 'UNEXPECTED_CALCULATION_ERROR',
    UNRELIABLE_CALCULATION: 'UNRELIABLE_CALCULATION',
} as const;

export const MAPPING_TYPE = {
    AUTOMATIC: 'AUTOMATIC',
    MANUAL: 'MANUAL',
} as const;

export const ROW_MAPPING_TARGET = {
    DESCRIPTOR_LABEL: 'DESCRIPTOR_LABEL',
    POSITION: 'POSITION',
    REPORTED_AS_LABEL: 'REPORTED_AS_LABEL',
    UNKNOWN: 'UNKNOWN',
    VALUE: 'VALUE',
    /** Special case used to point to the main initial mapping*/
    SELF: 'SELF',
} as const;

export const ROW_MAPPING_TYPE = {
    EXCLUSION: 'EXCLUSION',
    FULL: 'FULL',
    IGNORE_SPACE_AND_CASE: 'IGNORE_SPACE_AND_CASE',
    LETTER_ONLY: 'LETTER_ONLY',
    PARTIAL: 'PARTIAL',
    UNKNOWN: 'UNKNOWN',
    /** Special case used to point to the main initial mapping*/
    INITIAL: 'INITIAL',
} as const;

export const CELL_METADATA_DATA_TYPE = {
    CHANGE_HEADER: 'CHANGE_HEADER',
    DASH: 'DASH',
    DATE_HOLDER: 'DATE_HOLDER',
    NOTES_HEADER: 'NOTES_HEADER',
    NO_DATA: 'NO_DATA',
    NUMBER: 'NUMBER',
    NUMBERS_SATURATED_TEXT: 'NUMBERS_SATURATED_TEXT',
    PERCENT: 'PERCENT',
    TEXT: 'TEXT',
} as const;

export const NUMBER_FORMAT_WARNING = {
    BRACKETS_WITH_NEGATIVE_DATA: 'BRACKETS_WITH_NEGATIVE_DATA',
    DECIMAL_SEPARATORS_NOT_CONFIRMED: 'DECIMAL_SEPARATORS_NOT_CONFIRMED',
    NUMBERS_IN_DIFFERENT_FORMATS: 'NUMBERS_IN_DIFFERENT_FORMATS',
} as const;

export const METADATA_TYPE = {
    AUTOMATIC: 'AUTOMATIC',
    MANUAL: 'MANUAL',
} as const;

export const FIELD_PROP = {
    CALCS_DISABLED: 'calcsDisabled',
    MANUALLY_CALCULATED: 'manuallyCalculated',
    EXTENDED_SEARCH: 'extendedSearch',
    SRC: 'src',
    NOTES: 'notes',
    CORRECTION: 'correction',
    CORE_VALUE: 'core value',
} as const;

export const ERROR_PROMPTING_IMPACT_FIELD_PROPS = [
    FIELD_PROP.CALCS_DISABLED,
    FIELD_PROP.MANUALLY_CALCULATED,
    FIELD_PROP.EXTENDED_SEARCH,
    FIELD_PROP.SRC,
    FIELD_PROP.NOTES,
    FIELD_PROP.CORRECTION,
] as string[];

export const UTILITIES_PANEL_TAB = {
    RESOURCE: 'RESOURCE',
    MAPPINGS: 'MAPPINGS',
    MASTER_TABLE: 'MASTER_TABLE',
} as const;

export const UTILITIES_PANEL_TABS = Object.values(UTILITIES_PANEL_TAB);

export const FINANCIAL_SOURCE = {
    REPORT: 'REPORT',
    PRESS_RELEASE: 'PRESS_RELEASE',
    PRESENTATION: 'PRESENTATION',
    OTHER: 'OTHER',
    EIGHT_K: 'EIGHT_K',
    EIGHT_Q: 'EIGHT_Q',
    TEN_K: 'TEN_K',
    TEN_Q: 'TEN_Q',
    MIXED: 'MIXED',
    WEBSITE: 'WEBSITE',
    REPORT_SUPPLEMENT: 'REPORT_SUPPLEMENT',
    NA: 'NA',
} as const;

export const FINANCIAL_SOURCES = Object.values(FINANCIAL_SOURCE);

export const FINANCIAL_SOURCE_LABEL = {
    [FINANCIAL_SOURCE.REPORT]: 'Report',
    [FINANCIAL_SOURCE.PRESS_RELEASE]: 'Press Release',
    [FINANCIAL_SOURCE.PRESENTATION]: 'Presentation',
    [FINANCIAL_SOURCE.OTHER]: 'Other',
    [FINANCIAL_SOURCE.EIGHT_K]: '8K',
    [FINANCIAL_SOURCE.EIGHT_Q]: '8Q',
    [FINANCIAL_SOURCE.TEN_K]: '10K',
    [FINANCIAL_SOURCE.TEN_Q]: '10Q',
    [FINANCIAL_SOURCE.MIXED]: 'Mixed',
    [FINANCIAL_SOURCE.WEBSITE]: 'Website',
    [FINANCIAL_SOURCE.REPORT_SUPPLEMENT]: 'Report Supplement',
    [FINANCIAL_SOURCE.NA]: 'NA',
} as const;

export const MAPPING_DRAGGED_ITEM_TYPE = {
    IMPORT_DESCRIPTOR: 'IMPORT_DESCRIPTOR',
    MASTER_DESCRIPTOR: 'MASTER_DESCRIPTOR',
} as const;

export const HIGHLIGHTER_VARIANT = {
    PRIMARY: 'PRIMARY',
    SECONDARY: 'SECONDARY',
    TERTIARY: 'TERTIARY',
    QUATERNARY: 'QUATERNARY',
} as const;
